const config = {
  firebase: {
    apiKey: "AIzaSyD2Vr-h-hJ18C-pfw9lsRvtkc6WuF346dk",
    authDomain: "sweetcamel-e62cf.firebaseapp.com",
    projectId: "sweetcamel-e62cf",
    storageBucket: "sweetcamel-e62cf.firebasestorage.app",
    messagingSenderId: "249233034105",
    appId: "1:249233034105:web:946fdc12b87e04ea693da8",
    measurementId: "G-0DZ43ZPKRN"
  },
  line: {
    channelAccessToken: "2006952117",
    channelSecret: "6e665bf9470e9d1c6d5b562394ec43d9",
  },
};

export default config;
